/* ============================================================
   Watch Reserves — "Notify me" for sold-out pieces.

   The Notify me button takes the Add to Cart slot whenever the selected
   variant is unavailable (pure CSS on the Buy button's disabled state).
   This opens the panel and registers the email with Klaviyo's
   back-in-stock subscription endpoint for that variant. Klaviyo's Back in
   Stock flow sends the alert when inventory returns.

   Availability is read from the Buy button's disabled state rather than
   duplicated here: wr-pdp.js already flips it on every variant change, so
   a MutationObserver on the button closes the panel when a variant is in
   stock, without wr-pdp.js knowing this file exists.

   On success the email is also passed to Klaviyo's onsite identify
   (Oct 2026) so this browser's later activity lands on the profile.
   ============================================================ */
(function () {
  'use strict';

  var panel = document.querySelector('[data-wr-notify]');
  var buyBtn = document.querySelector('[data-wr-buy]');
  if (!panel || !buyBtn) return;

  var form = panel.querySelector('[data-wr-notify-form]');
  var input = panel.querySelector('#wr-notify-email');
  var submit = panel.querySelector('[data-wr-notify-submit]');
  var note = panel.querySelector('[data-wr-notify-note]');
  var busy = false;

  function variantId() {
    var el = document.querySelector('[data-wr-variant-id]');
    return el ? el.value : '';
  }

  function say(message) {
    note.textContent = message || '';
    note.hidden = !message;
  }

  // Ties this browser to the email in Klaviyo; no-op if onsite JS is off.
  function identify(email) {
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify({ email: email });
      } else {
        (window._learnq = window._learnq || []).push(['identify', { $email: email }]);
      }
    } catch (e) { /* not worth surfacing */ }
  }

  function open() {
    panel.hidden = false;
    document.querySelectorAll('[data-wr-notify-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'true');
    });
    panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    if (!panel.classList.contains('is-done') && input) input.focus({ preventScroll: true });
  }

  // The buttons are in the markup (Add to Cart slot + sticky bar); CSS shows
  // them only while the Buy button is disabled.
  document.querySelectorAll('[data-wr-notify-open]').forEach(function (b) {
    b.addEventListener('click', open);
  });

  function sync() {
    if (!buyBtn.disabled) panel.hidden = true;

    // A different variant is a different subscription.
    if (panel.dataset.variant && panel.dataset.variant !== variantId()) {
      panel.classList.remove('is-done');
      say('');
    }
  }

  new MutationObserver(sync).observe(buyBtn, { attributes: true, attributeFilter: ['disabled'] });
  sync();

  if (buyBtn.disabled && (/[?&]notify=1/.test(location.search) || location.hash === '#notify')) {
    open();
    panel.scrollIntoView({ block: 'center' });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (busy) return;

    var email = (input.value || '').trim();
    if (!email || email.indexOf('@') === -1 || email.indexOf('.') === -1) {
      say('Please enter a valid email address.');
      input.focus();
      return;
    }
    var honeypot = form.querySelector('input[name="company"]');
    if (honeypot && honeypot.value) return;

    var id = variantId();
    busy = true;
    submit.disabled = true;
    say('');

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + panel.dataset.company, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2025-01-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + id } }
          }
        }
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Klaviyo returned ' + r.status);
        identify(email);
        panel.dataset.variant = id;
        panel.classList.add('is-done');
        say("You're on the list. We'll email you if this piece returns.");
      })
      .catch(function () {
        say("That didn't go through. Please try again in a moment.");
      })
      .finally(function () {
        busy = false;
        submit.disabled = false;
      });
  });
})();
